import { defineStore } from "pinia";
import axios from "axios";
import { eventBus } from "../../../assets/eventBus";
import { piniaPlugin } from "../../index";

export const useMoveStore = defineStore("move", {
    state: () => ({
        store: piniaPlugin(),
        isShowMoveModal: false,
        isButtonLoading: false,
        submitButtonText: null,
        errors: {},
        allFolderData: [],
        selectedFolderId: null,
        isFolderLoader: false,
        isCheckingValidation: false,
        allItems: []
    }),
    getters: {},
    actions: {
        showMoveModal(item) {
            if (item !== null) {
                this.store.useMultiSelect.selectedItems = [];
                this.allItems.push({
                    id: item.encryptedId,
                    dataType: item.dataType,
                    type: item.type
                });
            } else {
                this.allItems = this.store.useMultiSelect.selectedItems;
            }
            this.validateFolderFile();
        },
        hideMoveModal() {
            this.isShowMoveModal = false;
            this.store.useMultiSelect.showTopProgress = false;
            this.isButtonLoading = false;
            this.submitButtonText = "Confirm";
            this.errors = {};
            this.allFolderData = [];
            this.allItems = [];
            this.selectedFolderId = null;
            this.isFolderLoader = false;
            this.store.useMultiSelect.toast = {
                isSuccess: false,
                successMsg: null,
                isToastMessage: false,
            };
            this.isCheckingValidation = false;
        },
        loadMovableFolders() {
            this.folderLoader = true;
            axios
                .post(route("get-move-folder-list"), { type: "own" }, {})
                .then((response) => {
                    this.allFolderData = response.data.data.map((item) => {
                        return {
                            id: item.encryptedId,
                            name: item.document_name,
                        };
                    });
                    this.isFolderLoader = false;
                })
                .catch((err) => {
                    this.store.useMultiSelect.toast = {
                        isSuccess: false,
                        successMsg: "Something went wrong!",
                        isToastMessage: true,
                    };
                    this.allFolderData = [];
                    this.isFolderLoader = false;
                });
        },
        validateFolderFile() {
            this.isCheckingValidation = true;
            axios
                .post(
                    route("validate-is-movable"),
                    { items: this.allItems },
                    {}
                )
                .then((response) => {
                    if (!response.data.success) {
                        this.store.useMultiSelect.toast = {
                            isSuccess: response.data.success,
                            successMsg: response.data.message,
                            isToastMessage: true,
                        };
                    } else {
                        this.loadMovableFolders();
                        this.submitButtonText = "Confirm";
                        this.isShowMoveModal = true;
                    }
                    this.isCheckingValidation = false;
                })
                .catch((err) => {
                    this.store.useMultiSelect.toast = {
                        isSuccess: false,
                        successMsg: "Something went wrong!",
                        isToastMessage: true,
                    };
                    this.isCheckingValidation = false;
                });
        },
        moveFolderFile(userTypeAbbr) {
            this.isButtonLoading = true;
            this.store.useMultiSelect.showTopProgress = true;
            this.submitButtonText = `<i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>Loading`;
            let routeUrl = route(userTypeAbbr + "-vault-move-file-folder");
            axios
                .post(
                    routeUrl,
                    {
                        items: this.allItems,
                        folderId:
                            this.selectedFolderId?.id ?? this.selectedFolderId,
                    },
                    {}
                )
                .then((response) => {
                    this.store.useMultiSelect.toast = {
                        isSuccess: response.data.success,
                        successMsg: response.data.message,
                        isToastMessage: true,
                    };
                    eventBus.reloadFolderFile("Delete", "folders");
                    eventBus.reloadFolderFile("Delete", "files");
                })
                .catch((err) => {
                    if (err.response.status == 422) {
                        if (err.response.data.errors.items) {
                            this.store.useMultiSelect.toast = {
                                isSuccess: false,
                                successMsg: err.response.data.errors.items[0],
                                isToastMessage: true,
                            };
                        }
                        this.errors = {
                            folderId: err.response.data.errors.folderId
                                ? err.response.data.errors.folderId[0]
                                : null,
                        };
                    } else if (err.response.status == 404) {
                        this.errors = {
                            message: err.response.data.message,
                        };
                    } else if (err.response.status == 401) {
                        this.store.useMultiSelect.toast = {
                            isSuccess: err.response.data.success,
                            successMsg: err.response.data.message,
                            isToastMessage: true,
                        };
                    } else {
                        this.store.useMultiSelect.toast = {
                            isSuccess: false,
                            successMsg: "Something Went Wrong!",
                            isToastMessage: true,
                        };
                    }
                    this.isButtonLoading = false;
                    this.store.useMultiSelect.showTopProgress = false;
                    this.submitButtonText = "Confirm";
                });
        },
    },
});
